/**
 * Mount zoom-out product card title/price from <template> only when zoom-out grid view is active.
 * Keeps duplicate title/price out of the default crawl DOM.
 *
 * @param {Element | null} grid
 * @param {string | null} view
 */
export function syncProductGridZoomOutDetails(grid, view) {
  if (!(grid instanceof HTMLElement)) return;

  const isZoomOut = view === 'zoom-out';

  grid.querySelectorAll('template[data-product-card-zoom-out-template]').forEach((template) => {
    const mount = template.nextElementSibling;

    if (!(mount instanceof HTMLElement) || !mount.classList.contains('product-grid-view-zoom-out--details-mount')) {
      return;
    }

    if (isZoomOut) {
      if (!mount.firstElementChild) {
        mount.appendChild(template.content.cloneNode(true));
      }

      mount.hidden = false;
      mount.removeAttribute('aria-hidden');
    } else {
      mount.replaceChildren();
      mount.hidden = true;
      mount.setAttribute('aria-hidden', 'true');
    }
  });
}

/**
 * Restore stored grid density and sync zoom-out mounts before first paint where possible.
 */
export function applyStoredProductGridView() {
  const grid = document.querySelector('.product-grid');

  if (!(grid instanceof HTMLElement)) return;

  const currentDevice = window.innerWidth >= 750 ? 'desktop' : 'mobile';
  const storedLayout = sessionStorage.getItem(`product-grid-view-${currentDevice}`);

  if (!storedLayout) return;

  grid.setAttribute('product-grid-view', storedLayout);

  document.querySelectorAll('input[type="radio"][name="grid"]').forEach((option) => {
    if (option instanceof HTMLInputElement) {
      option.checked = option.value === storedLayout;
    }
  });

  syncProductGridZoomOutDetails(grid, storedLayout);
}

if (typeof document !== 'undefined') {
  const run = () => applyStoredProductGridView();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
}
